import React, { createContext, useState, useEffect } from "react";

// Create the UserContext
export const EnquiryContext = createContext();

// Create a provider component
export const EnquiryProvider = ({ children }) => {
    // Get the enquiry data from localStorage, parsing it as JSON
    const storedEnquiry = JSON.parse(localStorage.getItem("enquiry")) || null;

    const [enquiry, setEnquiry] = useState(storedEnquiry);

    // Update localStorage whenever the enquiry changes
    useEffect(() => {
        if (enquiry !== null) {
            localStorage.setItem("enquiry", JSON.stringify(enquiry));
        }
    }, [enquiry]);

    return (
        <EnquiryContext.Provider value={{ enquiry, setEnquiry }}>
            {children}
        </EnquiryContext.Provider>
    );
};
